import React, { useState } from "react";
import classes from "../helpCenter.module.css";
import NewToolTip from "../../../components/NewToolTip";
import { HELP_CENTER_EVENTS } from "../../../services/webengage/webEngageConstants";
import LogService from "../../../services/LogService";
import { HELP_CONTACT } from "../../../services/HelpCenterService/HelpCenterConstant";
import { detectMobile } from "../../../services/utils";
import cx from "classnames";
import CallButton from "./CallButton";

const CallCenter = ({ customClass, iconOnly = false }) => {
  const [showCallTip, setCallTip] = useState(false);
  const [isCoppied, setCopySuccess] = useState("");

  function openCallTip() {
    LogService.log(HELP_CENTER_EVENTS.HELP_CENTER_CALL_CLICKED, {
      url: window.location.pathname
    });
    setCallTip(true);
  }

  function handleCloseTip() {
    setCallTip(false);
    setCopySuccess("");
  }

  function copyPhone() {
    try {
      navigator.clipboard.writeText(HELP_CONTACT);
      LogService.log(HELP_CENTER_EVENTS.HELP_CENTER_COPY_CLICKED, {
        url: window.location.pathname
      });
      setCopySuccess("Copied!");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
    setTimeout(() => {
      setCopySuccess("");
    }, 5000);
  }
  return (
    <>
      <CallButton
        customClass={customClass}
        iconOnly={iconOnly}
        onClick={openCallTip}
      />
      {showCallTip ? (
        <NewToolTip
          rootClass={cx(
            iconOnly && classes.iconTipContent,
            classes.callContent
          )}
          tipClass={cx(iconOnly && classes.iconTipClass, classes.tipClass)}
          showTip={true}
          handleClose={handleCloseTip}
          keepScrollEvent={false}
          tipUrl={"/hire/tipUp.svg"}
        >
          <div className={classes.helpContent}>
            Need to get in touch?
            <div className={classes.calllink}>
              {detectMobile() ? (
                <a
                  href={`tel:${HELP_CONTACT}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {HELP_CONTACT}
                </a>
              ) : (
                HELP_CONTACT
              )}
              {isCoppied ? (
                <span className={classes.copied}>{isCoppied}</span>
              ) : (
                <img
                  src="/hire/copy.svg"
                  alt="copy"
                  height={17}
                  width={17}
                  className={classes.copyIcon}
                  onClick={copyPhone}
                />
              )}
            </div>
          </div>
        </NewToolTip>
      ) : null}
    </>
  );
};

export default CallCenter;
